import styled from 'styled-components';

export const DropdownWrapper = styled.div `
    .dropdown {
      position: relative;

      .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid rgb(230 230 230);
        padding: .375rem .75rem;
        font-size: 12px;
        line-height: 1.8;
        cursor: pointer;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      }

      .dropdown-toggle {
        white-space: nowrap;
        
        &:after {
          display: inline-block;
          margin-left: .255em;
          vertical-align: .255em;
          content: "";
          border-top: .3em solid;
          border-right: .3em solid rgb(0 0 0 / 0%);
          border-bottom: 0;
          border-left: .3em solid rgb(0 0 0 / 0%);
        }
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 8.5rem;
        padding: .5rem 0;
        margin: .125rem 0 0;
        font-size: 1rem;
        color: #212529;
        text-align: left;
        list-style: none;
        background-color: #FFFFFF;
        background-clip: padding-box;
        border: 1px solid #00000026;
        border-radius: .25rem;

        &.show {
          display: block;
        }

        .dropdown-item {
          display: block;
          width: 100%;
          padding: .25rem 1.5rem;
          clear: both;
          font-weight: 400;
          color: #212529;
          text-align: inherit;
          white-space: nowrap;
          background-color: transparent;
          border: 0;
          cursor: pointer;
          color: #6f696a;
          line-height: 1.5;
          font-weight: bold;

          :hover {
            background-color: #D8EAFC;
          }
        }
      }
    }
`;